import React, { useEffect, useRef, useState } from 'react';
import { ChevronLeft, ChevronRight } from "lucide-react";
import bg3 from '../imgs/dia-diem-du-lich-he-7.jpeg';
import codung from '../imgs/codung.png';
import maichau from '../imgs/maichau.png';
import cohy from '../imgs/cohy.png';
import socson from '../imgs/socson.jpg';
import sapa from '../imgs/sapa.png';
import maichau2 from '../imgs/maichau.jpg';

const data = [
  {
    title: 'Co Dung Heron Eco-Retreat',
    location: 'Thach That, Hanoi City.',
    size: '3 hectare',
    deployment: 'June 2021',
    img: codung
  },
  {
    title: 'Vinh Hy Rest Stop',
    location: 'Vinh Hy Bay',
    size: '4 hectare',
    deployment: 'August 2021',
    img: cohy
  },
  {
    title: 'Mai Chau – Sol Bungalows Resort',
    location: 'Mai Chau, Phu Tho Province',
    size: '8000 m2',
    deployment: 'Dec 2021',
    img: maichau
  },
  {
    title: 'Paradise Soc Son Resort',
    location: 'Soc Son, Ha Noi City',
    size: '8 hectare',
    deployment: 'May 2024',
    img: socson
  },
  {
    title: 'Sapa Destination',
    location: 'Sapa, Lao Cai Province',
    size: '5,2 hectare',
    deployment: 'Dec 2021',
    img: sapa
  },
  {
    title: 'Jade de Mai Chau',
    location: 'Phu Tho Province',
    size: '6 hectare',
    deployment: '2023',
    img: maichau2
  },
];

const Slider_Mobile = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const intervalRef = useRef(null);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % data.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + data.length) % data.length);
  };

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      nextSlide();
    }, 3000);
    return () => clearInterval(intervalRef.current);
  }, []);

  const getVisibleItems = () => {
    const items = [
      data[currentIndex],
      data[(currentIndex + 1) % data.length],
    ];
    return items;
  };

  return (
    <section className="relative bg-[#0B1D26] h-[682px] py-20 block md:hidden overflow-hidden">

      {/* Gradient Overlays */}
      <div className="absolute inset-0 z-0">
        <img src={bg3} alt="background" className="w-full h-full object-cover" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B1D26] via-[#0B1D26]/50 to-transparent z-0" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B1D26] via-[#0B1D26]/20 to-transparent z-0" />

      {/* Title */}
      <div className="relative h-[40px] flex items-center mb-4 w-full mt-[0px] md:mt-[20px] ml-4 md:ml-[50px] ">
        {/* Chữ mờ lớn phía sau */}
        <h2 className="absolute text-[43px] md:text-[90px] font-bold text-white/10 uppercase leading-none z-0 select-none left-0">
          OUR PROJECTS
        </h2>

        {/* Chữ nhỏ phía trước */}
        <div className="relative z-10 flex items-center space-x-3">
          <div className="w-[30px] h-0.5 bg-yellow-400"></div>
          <h3 className="text-yellow-400 uppercase tracking-widest text-[14px] md:text-[22px] font-semibold">
            OUR PROJECTS
          </h3>
        </div>
      </div>

      {/* Slider */}
      <div className="relative z-20 px-4 flex justify-center">
        <div className="w-[300px] h-[450px] bg-white/5 backdrop-blur-md border border-white/20 rounded-2xl p-4 flex flex-col items-center">
          {/* Cards */}
          <div className="flex gap-4 overflow-hidden transition-transform duration-500 ease-in-out">
            {getVisibleItems().map((item, index) => (
              <div
                key={index}
                className="bg-[#0B1D26]/60 backdrop-blur-lg rounded-xl border border-white/10 w-[128px] h-[360px] flex-shrink-0 p-3 text-white"
              >
                <img
                  src={item.img}
                  alt={item.title}
                  className="rounded-md w-full h-[100px] object-cover mb-2"
                />
                <h4 className="text-sm font-semibold leading-snug mb-2 text-center">
                  {item.title}
                </h4>
                <ul className="text-xs text-left space-y-1">
                  <li>Project: {item.title}</li>
                  <li>Client: Launchzone</li>
                  <li>Size: {item.size}</li>
                  <li>Investment Volume: $4M</li>
                </ul>
              </div>
            ))}
          </div>

          {/* Arrows */}
          <div className="flex justify-center gap-6 mt-4">
            <button
              onClick={prevSlide}
              className="w-9 h-9 flex items-center justify-center text-white bg-white/20 hover:bg-white/30 rounded-full"
            >
              <ChevronLeft size={18} />
            </button>
            <button
              onClick={nextSlide}
              className="w-9 h-9 flex items-center justify-center text-white bg-white/20 hover:bg-white/30 rounded-full"
            >
              <ChevronRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Slider_Mobile;
